import { GCInstant as platform } from 'src/lib/gcinstant';
import { isLineIAPAvailable } from 'src/game/iap/component/iap.api';
import { user } from 'src/StateObserver';

const PUZZLE_PINCH_TOS_LEVEL_THRESHOLD = 30;
export const TOS_PUZZLE_PINCH_REWARD_MOVES = 5;

export function shouldShowTosPuzzlePinchNudge(): boolean {
  if (!isLineIAPAvailable()) return false;

  const hasAcceptedTos =
    platform.storage.linePurchaseTOSLastAcceptedAt !== undefined;
  if (hasAcceptedTos) return false;

  const state = user();
  if (state.match2.level < PUZZLE_PINCH_TOS_LEVEL_THRESHOLD) return false;

  return state.match2.losingStreak === 0;
}
